import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const box: SxStyle = {
  display: 'flex',
  alignItems: 'center',
};
